module.exports = __webpack_public_path__ + "img/dg-youtube-playlist-all.86648990.png";